import { useAuth0 } from "@auth0/auth0-react";
import { Clock, LogOut } from "lucide-react";

import promptStyle from "../prompt.module.css";
import buttonStyle from "../../Common/buttons.module.css";

/**
 * Displays a static "Please wait for approval" message, no checks.
 */
function WaitForApproval() {
  const { logout } = useAuth0();

  return (
    <div className={promptStyle.loneTextWrapper}>
      <h3 className={promptStyle.title}>
        <span className={promptStyle.blueText}>
          <Clock
            stroke="var(--light-blue-icon)"
            strokeWidth={1.5}
            className={promptStyle.adHocIcon}
          />
          Please wait for approval
        </span>
      </h3>

      <br />

      <p className={promptStyle.observations}>
        Your account is pending approval by an administrator.
        <br />
        You’ll be able to continue once it’s approved.
      </p>

      <div className={promptStyle.bottomText}>
        Already approved?
        <span
          onClick={() =>
            logout({ logoutParams: { returnTo: window.location.origin } })
          }
          className={
            buttonStyle.button +
            " " +
            buttonStyle.lightBlueOutline +
            " " +
            promptStyle.alreadyVerified
          }
        >
          <LogOut
            stroke="var(--light-blue-icon)"
            strokeWidth={1.5}
            className={promptStyle.adHocIcon}
          />
          Log out and sign in again
        </span>
      </div>
    </div>
  );
}

export default WaitForApproval;
